import React from "react";
import { faFolderOpen } from "@fortawesome/free-regular-svg-icons";
import RequestPreview from "./overview/preview/RequestPreview";
import { isTouch } from "../../utils/screenUtil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router";
import Tooltip from "../../common/tooltip/Tooltip";

function ReceivedItem({ id, label, item, index, activeJournalId, setActiveJournalId }) {
  const history = useHistory();
  return (
    <>
      <div className="subtitle">{label}</div>
      <RequestPreview
        className={isTouch() && index > 0 ? "mt-6" : ""}
        key={`receivedItem${index}`}
        {...item}
        blur={activeJournalId && activeJournalId !== item.uid}
        setActiveJournalId={setActiveJournalId}
        renderRequestActions={() => (
          <Tooltip
            content={"Zaprimljeni dokumenti"}
            children={
              <FontAwesomeIcon
                className="is-clickable"
                icon={faFolderOpen}
                onClick={() =>
                  history.push(
                    `/receivedRequests/${item.id}/submissions/${item.uid}/previewDocuments`
                  )
                }
                size="2x"
              />
            }
          ></Tooltip>
        )}
      />
    </>
  );
}

export default ReceivedItem;
